"use strict";

import module from "./module";

import "./baseFunction.spec";

export default module;
